import React from 'react';
import { Box, FormControl, FormHelperText, InputLabel } from '@mui/material';
import { Field, FieldAttributes, FieldProps } from 'formik';
import { GeosuggestSuggest, MuiGeosuggest } from 'lib/MuiGeosuggest';

interface GeosuggestFormFieldProps {
    label?: React.ReactNode;
    description?: React.ReactNode;
}

export const GeosuggestFormField: React.FC<FieldAttributes<GeosuggestFormFieldProps>> = ({
    label,
    placeholder: _placeholder,
    description,
    ...props
}) => (
    <Field {...props}>
        {(childProps: FieldProps) => (
            <GeosuggestFormFieldComponent label={label} description={description} {...childProps} />
        )}
    </Field>
);

const GeosuggestFormFieldComponent: React.FC<FieldProps & GeosuggestFormFieldProps> = ({
    description,
    field,
    meta,
    label
}) => {
    const isError = meta.touched && !!meta.error;
    const handleChange = React.useCallback(
        (value: GeosuggestSuggest) => {
            field.onChange({ target: { value, name: field.name } });
        },
        [field]
    );
    return (
        <FormControl fullWidth error={meta.touched && !!meta.error}>
            <Box marginBottom={2}>
                <InputLabel shrink>{label}</InputLabel>
            </Box>
            <MuiGeosuggest onChange={null} value={field.value} onSuggestSelect={handleChange} />
            {(isError || description) && (
                <FormHelperText error={isError}>{isError ? meta.error : description}</FormHelperText>
            )}
        </FormControl>
    );
};
